(function () {
  var INTERVAL_MS = 8000;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function init() {
    var nodes = document.querySelectorAll('[data-password-logo-switch]');
    if (!nodes.length || prefersReducedMotion()) return;

    var timers = [];

    nodes.forEach(function (el) {
      var tick = function () {
        el.classList.toggle('is-secondary');
      };

      var id = window.setInterval(tick, INTERVAL_MS);
      timers.push({ el: el, id: id });
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        timers.forEach(function (t) {
          window.clearInterval(t.id);
        });
      } else {
        timers.forEach(function (t) {
          window.clearInterval(t.id);
          t.id = window.setInterval(function () {
            t.el.classList.toggle('is-secondary');
          }, INTERVAL_MS);
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
